<template>
  <div class="one_box" ref="info_body">
      <div class="one_main">
          <div class="one_m_tit1">{{$t('main.text21')}}</div>
          <div class="one_m_tit2">{{$t('main.text110')}}</div>
          <div class="one_m_tit3">{{$t('main.text111')}}</div>
          <div class="one_m_tit4">
                 <el-radio-group :disabled="input_dab" v-model="radio" @change="radio_type(radio)">
                    <el-radio label="true">{{$t('main.text112')}}</el-radio>
                    <el-radio label="false">{{$t('main.text113')}}</el-radio>
                </el-radio-group>
          </div>

          <template v-if="radio!='' ">
              <el-form class="form_box">
                  <template v-if="radio=='true' ">
                    <div>
                        <el-form-item v-for="(item,index) in corporate_fi" :key="index">

                            <div class="box_top_tit" v-if="index==0">
                                <div>{{$t('main.text114')}}</div>
                                <div>
                                    <!-- <a class="down_pdf" href="/pdf/AML_Questionnaire.pdf" download target="_blank">1122</a> -->
                                    <a class="down_pdf" href="/pdf/AML_Questionnaire.pdf" target="_blank">
                                        <img src="../../../assets/img/down_pdf.png" alt="">
                                        <!-- Download here -->
                                        {{$t('main.text243')}}
                                    </a>
                                </div>
                            </div>
                            <div class="box_top_tit" v-else-if="index==1">{{$t('main.text115')}}</div>
                            <div class="box_top_tit" v-else-if="index==2">{{$t('main.text116')}}</div>
                            <div class="box_top_tit" v-else-if="index==3">{{$t('main.text117')}}</div>
                            <div class="box_top_tit" v-else-if="index==4">
                                <div>{{$t('main.text118')}}</div>
                                <div>{{$t('main.text119')}}</div>
                            </div>
                            <div class="box_top_tit" v-else-if="index==5">
                                <div>{{$t('main.text120')}}</div>
                                <div>{{$t('main.text121')}}</div>
                            </div>
                            <div class="box_top_tit" v-else-if="index==6">
                                <div>{{$t('main.text58')}}</div>
                                <div>{{$t('main.text58_y')}}</div>
                            </div>
                            <div class="box_top_tit" v-else-if="index==7">
                                <div>{{$t('main.text122')}}</div>
                                <div>{{$t('main.text121')}}</div>
                            </div>
                            <div class="box_top_tit" v-else-if="index==8">
                                <div>{{$t('main.text59')}}</div>
                                <div>{{$t('main.text121')}}</div>
                            </div>
                            <div class="box_top_tit" v-else-if="index==9">{{$t('main.text57')}}</div>
                            <div class="box_top_tit" v-else-if="index==10">{{$t('main.text123')}}</div>
                            <div class="box_top_tit" v-else-if="index==11">
                                <div>{{$t('main.text61')}}</div>
                                <div>{{$t('main.text124')}}</div>
                            </div>
                            <div class="box_top_tit" v-else-if="index==12">{{$t('main.text62')}}</div>

                            <!-- :file-list="set_item_url(item.url,item.index)" -->
                            <el-upload
                                :disabled="input_dab"
                                class="upload-demo upload_box"
                                drag
                                :limit="10"
                                action="#"
                                ref="upload-file"
                                :show-file-list="true"
                                :file-list="set_item_url(item.url,item.index)"
                                accept=".jpg,.jpeg,.png,.JPG,.JPEG,.pdf,.PDF"
                                :http-request="ossUpload_assistant"
                                :before-remove="function(file,fileList){child_beforeRemove(file,fileList,index)}"
                                :data="{data_index:index}"
                                multiple>
                                    <img class="load_icon" src="../../../assets/img/user_upload_img.png" alt="">
                                    <div class="el-upload__text upload_text">
                                        <div>{{$t('main.text88')}}</div>
                                        <div><el-button class="upload_btn">{{$t('main.text89')}}</el-button></div>
                                        <div>{{$t('main.text90')}}</div>
                                    </div>
                            </el-upload>
                        </el-form-item>

                    </div>
                  </template>

                  <template v-else>
                      <div>
                          <el-form-item v-for="(item,index) in corporate_fi" :key="index">

                            <div class="box_top_tit" v-if="index==0">
                                <div>{{$t('main.text118')}}</div>
                                <div>{{$t('main.text118_y')}}</div>
                                <div>{{$t('main.text118_y2')}}</div>
                            </div>
                            <div class="box_top_tit" v-else-if="index==1">
                                <div>{{$t('main.text120')}}</div>
                                <div>{{$t('main.text121')}}</div>
                            </div>
                            <div class="box_top_tit" v-else-if="index==2">
                                <div>{{$t('main.text58')}}</div>
                                <div>{{$t('main.text58_y')}}</div>
                            </div>
                            <div class="box_top_tit" v-else-if="index==3">
                                <div>{{$t('main.text57')}}</div>
                            </div>
                            <div class="box_top_tit" v-else-if="index==4">
                                <div>{{$t('main.text122')}}</div>
                                <div>{{$t('main.text121')}}</div>
                            </div>
                            <div class="box_top_tit" v-else-if="index==5">
                                <div>{{$t('main.text61')}}</div>
                                <div>{{$t('main.text61_y')}}</div>
                            </div>
                            <div class="box_top_tit" v-else-if="index==6">
                                <div>{{$t('main.text126')}}</div>
                                <div>{{$t('main.text127')}}</div>
                            </div>
                            <div class="box_top_tit" v-else-if="index==7">
                                <div>{{$t('main.text59')}}</div>
                                <div>{{$t('main.text121')}}</div>
                            </div>
                            <div class="box_top_tit" v-else-if="index==8">
                                <div>{{$t('main.text62')}}</div>
                            </div>

                                <el-upload
                                    :disabled="input_dab"
                                    class="upload-demo upload_box"
                                    drag
                                    :limit="10"
                                    action="#"
                                    ref="upload-file"
                                    :show-file-list="true"
                                    :file-list="set_item_url(item.url,item.index)"
                                    accept=".jpg,.jpeg,.png,.JPG,.JPEG,.pdf,.PDF"
                                    :http-request="ossUpload_assistant"
                                    :before-remove="function(file,fileList){child_beforeRemove(file,fileList,index)}"
                                    :data="{data_index:index}"
                                    multiple>
                                        <img class="load_icon" src="../../../assets/img/user_upload_img.png" alt="">
                                        <div class="el-upload__text upload_text">
                                            <div>{{$t('main.text88')}}</div>
                                            <div><el-button class="upload_btn">{{$t('main.text89')}}</el-button></div>
                                            <div>{{$t('main.text90')}}</div>
                                        </div>
                                </el-upload>
                            </el-form-item>

                      </div>
                  </template>

                <el-form-item>
                    <el-button :disabled="input_dab" class="Submit_btn" @click="upload_all_data">{{$t('main.text104')}}</el-button>
                    <!-- <el-button :disabled="input_dab" class="Submit_btn" @click="old_data_new_data">新老数据对比</el-button> -->
                </el-form-item>

              </el-form>
          </template>
      </div>

      <!-- <userSave/> -->

    <!-- 切换 yes no -->
    <el-dialog
        :visible.sync="switc_hover_dlg"
        custom-class="log_out_dlg_bgc"
        append-to-body
        center
        :show-close="false"
        width="480px">
        <div class="log_out1">
            <img src="../../../assets/img/warning_icon.png" alt="">
        </div>
        <div class="log_out2">
          {{$t('main.text128')}}
        </div>
        <div class="log_out3">
          {{$t('main.text129')}}
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="switc_hover_dlg = false" class="cancel_btn">{{$t('main.text7')}}</el-button>
            <el-button type="primary" class="confirm_btn" @click="Confirm_btn">{{$t('main.text130')}}</el-button>
        </span>
    </el-dialog>

  </div>
</template>

<script>
import {awsS3Auth,kyc_corporate,getKycInfo} from '@/api/api';
// import {awsS3Auth,getKycInfo} from '@/api/api';
import AWS from 'aws-sdk';
export default {
    data() {
        return {
            awsS3_data:'',
            radio:'',
            show_child:true,
            corporate_fi:[
                {num:0,url:[],uid:[]},
                {num:1,url:[],uid:[]},
                {num:2,url:[],uid:[]},
                {num:3,url:[],uid:[]},
                {num:4,url:[],uid:[]},
                {num:5,url:[],uid:[]},
                {num:6,url:[],uid:[]},
                {num:7,url:[],uid:[]},
                {num:8,url:[],uid:[]},
                {num:9,url:[],uid:[]},
                {num:10,url:[],uid:[]},
                {num:11,url:[],uid:[]},
                {num:12,url:[],uid:[]}
            ],
            child_index_j:null,
            fileList:[],
            data_all:null,//是否全部填写数据
            api_kyc_info:[],
            switc_hover_dlg:false,
            api_radio_type:'',
            old_data:false,
            input_dab:false,// status 2 待审核   3审核中  4审核通过  5审核失败

            api_old_data:'',//老数据


        }
    },
    mounted() {
        this.S3Auth();
        this.get_kyc();
        this.bus.$on('router_4_child',(v)=>{
            if(v==1){
                // 重新触发 保存操作
                this.upload_all_data();
            }
        })
    },
    destroyed(){
        this.bus.$off('router_4_child')
    },
    watch:{
        radio(newv,oldv){
            if(oldv==''){
                this.old_data=false;
                this.switc_hover_dlg=false;
                this.set_dlg_ok();
            }else{
                this.old_data=true;
                this.switc_hover_dlg=true;
                // if(this.radio=='true'){
                //     this.radio='false';
                // }else{
                //     this.radio='true';
                // }
            }
        },
        corporate_fi:{ //监听的对象
            deep:true, //深度监听设置为 true
            handler:function(newV,oldV){
                newV;oldV;
                this.old_data_new_data();
            }
        }
        
    },
    
    methods: {
        // 随机数
        createCode() {
            var code = "";
            var codeLength = 10;
            var random = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9);
            for (var i = 0; i < codeLength; i++) {
                var index = Math.floor(Math.random() * 9);
                code += random[index];
            }
            return code;
        },
        async S3Auth() {
            const res = await awsS3Auth();
            if (res.data.code == 200) {
                this.awsS3_data = res.data.data;
                // console.log(this.awsS3_data);
                //参数
                AWS.config.update({
                region: "ap-southeast-1",
                credentials: new AWS.CognitoIdentityCredentials({
                    IdentityPoolId: this.awsS3_data.IdentityPoolId,
                    IdentityId: this.awsS3_data.IdentityId,
                    Logins: {
                    "cognito-identity.amazonaws.com": this.awsS3_data.Token,
                    },
                }),
                });
            }else{
                // this.$message.closeAll();
                // this.$message.error(res.data.msg);
                this.message.ismessage('error',res.data.msg);
            }
        },
        ossUpload_assistant(data){
            data;
            this.$store.state.aws_loading = true;
            this.show_child=false;
            // const uploadPath =  'autonym/'+this.createCode()+'/'+data.file.name;
            // type:"image/jpeg"
            let file_type = data.file.type.split("/")[1];
            const uploadPath =  'autonym/'+this.createCode()+'/'+this.random_16+'.'+file_type;
            let s3 = new AWS.S3();
            let params = {
                Body: data.file,
                Bucket: "data-storage-d3",
                Key: uploadPath,
                ACL: "public-read",
            };
            s3.putObject(params,(err)=>{
                if(err){
                    // console.error('error');
                    // console.log(err);
                    // console.log(err, err.stack);
                    // alert(err, err.stack);
                    this.$store.state.aws_loading=false;
                    return this.message.ismessage('error',this.$t('bank_card.Upload_error'));
                }else{
                    const url ="https://data-storage-d3.s3.ap-southeast-1.amazonaws.com/" +uploadPath;
                    // console.log(url);
                    this.corporate_fi[data.data.data_index].num=data.data.data_index;
                    this.corporate_fi[data.data.data_index].url.push(url);
                    this.corporate_fi[data.data.data_index].uid.push(data.file.uid);
                    this.$store.state.aws_loading=false;
                    this.show_child=true;

                }
            })

        },
        child_beforeRemove(file,fileList,index){
            file;fileList;index;
            for (let j = 0; j < this.corporate_fi[index].url.length; j++) {
                if(this.corporate_fi[index].url[j].indexOf(file.url)!=-1){
                    this.child_index_j=j;
                    break;
                }
            }

            this.corporate_fi[index].url.splice(this.child_index_j,1);
            this.corporate_fi[index].uid.splice(this.child_index_j,1);


        },
        get_kyc(){
            getKycInfo().then(res=>{
                if(res.data.code==200){
                    this.api_kyc_info=res.data.data;
                    if(res.data.data.corporate_fi_type==1){
                        this.radio='true';
                    }else if(res.data.data.corporate_fi_type==2){
                        this.radio='false';
                    }else{
                        this.radio='';
                    }
                    setTimeout(() => {
                        if(res.data.data.corporate_fi_info &&res.data.data.corporate_fi_info!=''){
                            let api_data=JSON.parse(res.data.data.corporate_fi_info);
                            // num 0-12 或者 0-8
                            for (let i = 0; i < api_data.length; i++) {
                                api_data[i].num=i;
                            }
                            this.corporate_fi=api_data;

                            this.api_old_data=JSON.parse(JSON.stringify(api_data));//老数据
                            
                        }
                    }, 100);

                    // status 2 待审核   3审核中  4审核通过  5审核失败
                    if(
                        res.data.data.status==2||
                        res.data.data.status==3||
                        res.data.data.status==4||
                        res.data.data.status==5
                       ){
                            this.input_dab=true;
                    }else{
                        this.input_dab=false;
                    }
                    
                }else{
                    this.message.ismessage('error',res.data.msg);
                }
            })
        },
        old_data_new_data(){
            if(this.api_old_data&&this.corporate_fi){
                let data_true=(JSON.stringify(this.api_old_data) == JSON.stringify(this.corporate_fi));
                this.$store.state.login.router_true=data_true;
            }else if(this.api_old_data==''&&this.corporate_fi){
                this.$store.state.login.router_true=false;
            }

        },
        upload_all_data(){

            // num 0-12 或者 0-8
            for (let i = 0; i < this.corporate_fi.length; i++) {
                this.corporate_fi[i].num=i;
            }

            if(this.radio=='true'){
                // num 10; num 12 不是必填
                for (let i = 0; i < this.corporate_fi.length; i++) {
                    if(this.corporate_fi[i].num!=10&&this.corporate_fi[i].num!=12){
                        if(this.corporate_fi[i].url.length<=0&&this.corporate_fi[i].uid.length<=0){
                            this.data_all=false;
                            break;
                        }else{
                            this.data_all=true;
                        }
                    }else{
                        this.data_all=true;
                    }
                }
            }else{
                for (let i = 0; i < this.corporate_fi.length; i++) {
                    if(this.corporate_fi[i].num!=8){
                        if(this.corporate_fi[i].url.length<=0&&this.corporate_fi[i].uid.length<=0){
                            this.data_all=false;
                            break;
                        }else{
                            this.data_all=true;
                        }
                    }else{
                        this.data_all=true;
                    }
                }
            }

            kyc_corporate({
                corporate_fi_status:this.data_all?1:0,
                corporate_fi_type:(this.radio=='true'?1:2),
                corporate_fi_info:this.corporate_fi
            })
            .then(res=>{
                if(res.data.code==200){
                    this.message.ismessage('success',this.$t('main.text108'));
                    this.get_kyc();
                    setTimeout(() => {
                        this.bus.$emit('info_4_all');
                    }, 100);
                }else{
                    this.message.ismessage('error',res.data.msg);
                    this.$store.state.login.data_no_router=false;
                }
            })


        },
        radio_type(v){
            v;
            if(!this.old_data) return;
            if(v=='true'){
                this.radio='false';
            }else{
                this.radio='true';
            }

        },
        set_item_url(item_url,index){
            let url=[];
            index;
            for (let i = 0; i < item_url.length; i++) {
                let text1=item_url[i];
                let text2=[];
                text2=text1.split("/");
                url.push({name:text2[5],url:text1})
            }
            return url;
        },
        Confirm_btn(){
            if(this.radio=='true'){
                this.radio='false';
                this.set_dlg_ok();
            }else{
                this.radio='true';
                this.set_dlg_ok();
            }
            setTimeout(() => {
                this.switc_hover_dlg=false;
            }, 100);
            
        },
        set_dlg_ok(){
            for (let i = 0; i < this.corporate_fi.length; i++) {
                this.corporate_fi[i].num='';
                this.corporate_fi[i].url=[];
                this.corporate_fi[i].uid=[];
            }
            
            if(this.radio=='true'){
                // yes 13
                if(this.corporate_fi.length < 13 ){
                    
                    let arr_length=13 - this.corporate_fi.length;
                    let new_arr=[];
                    for (let i = 0; i < arr_length; i++) {
                        new_arr.push({num:'',url:[],uid:[]})
                    }
                    this.corporate_fi.push(...new_arr);
                    for (let i = 0; i < this.corporate_fi.length; i++) {
                        this.corporate_fi[i].num=i;
                    }
                }
            }else{
                // no 9
                this.corporate_fi=this.corporate_fi.slice(0,9);
                for (let i = 0; i < this.corporate_fi.length; i++) {
                    this.corporate_fi[i].num=i;
                }
            }
        }


    },
}
</script>

<style scoped>
.one_box{
    flex: 1;
    background: #04182A;
    border-radius: 16px;
    box-sizing: border-box;
    padding: 60px 0;
}
.one_main{
    width: 420px;
    margin: auto;
}
.one_m_tit1{
    font-style: normal;
    font-weight: bold;
    font-size: 22px;
    line-height: 26px;
    margin-bottom: 8px;
}
.one_m_tit2{
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 18px;
    opacity: 0.8;
    margin-bottom: 40px;
}
.one_m_tit3{
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 18px;
    opacity: 0.8;
    margin-bottom: 8px;
}
.one_m_tit4 .el-radio__label{
    font-size: 15px;
}
.one_m_tit4 >>> .el-radio{
    color: #fff;
}
.one_m_tit4 >>> .el-radio__inner {
    border: 1px solid #fff;
    background-color: transparent;
}
.one_m_tit4 >>> .el-radio__input.is-checked .el-radio__inner {
    border-color: #fff;
    background: transparent;
}
.one_m_tit4 >>> .el-radio__inner::after {
    width: 7px;
    height: 7px;
    background-color: #fff;
}
.one_m_tit4 >>> .el-radio__input.is-checked+.el-radio__label {
    color: #fff;
}
.one_m_tit4 >>> .el-radio__inner:hover {
    border-color: #fff;
}


/* --上传-- */
.upload_header{
    height: 104px;
    background: #041728;
    display: flex;
    position: relative;
}
.upload_t_logo{
    width: 230px;
    margin: auto;
}
.upload_t_btn{
  border: 1.5px solid #F1C787;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 8px 20px;
  cursor: pointer;
  margin-left: 10px;
  color: #F1C787;
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translate(0,-50%);
}
.form_box{
    max-width: 420px;
    margin: auto;
    margin-top: 40px;
}
.form_tit{
    font-weight: bold;
    font-size: 22px;
    line-height: 26px;
    color: #314869;
    margin-top: 60px;
}
.upload_box >>> .el-upload{
    width: 100%;
}
.upload_box >>> .el-upload-dragger{
    background: rgba(222, 185, 129, 0.04);
    border: 1.5px dashed #DEB981;
    border-radius: 4px;
    width: 100%;
    height: 190px;
}
.icon_upload{
    margin: 10px auto 0;
    font-size: 50px;
}
.upload_text div{
    line-height: initial;
    color: rgba(255, 255, 255, 0.6);
}
.upload_btn{
    border-color: #F1C788;
    background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
    box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
    border-radius: 4px;
    font-weight: bold;
    font-size: 15px;
    /* line-height: 18px; */
    color: #04182A;
    margin: 12px auto;
    height: 38px;
}
.box_top_tit{
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 18px;
    color: rgba(255, 255, 255, 0.6);
    /* opacity: 0.6; */
    margin-bottom: 12px;
}
.el-form-item {
    margin-bottom: 15px;
}
.add_btn{
    width: 214px;
    height: 46px;
    text-align: center;
    line-height: 46px;
    border-radius: 4px;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    color: #DEB981;
    border: 1px solid #DEB981;
    cursor: pointer;
    margin: 30px auto;
    box-shadow: 0px 2px 4px rgb(222 185 129 / 20%);
}
.Submit_btn,
.Submit_btn:hover{
    background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
    box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
    border-radius: 4px;
    border-color: #F1C788;
    width: 100%;
    color: #04182A;
    margin-bottom: 30px;
}
.load_icon{
    width: 30px;
    vertical-align: middle;
    margin-top: 25px;
    margin-bottom: 10px;
}
.upload_body >>> .el-upload-list__item .el-icon-close-tip{
    display: none !important;
    color: transparent;
}

/* --over-- */
/* 退出弹框 */
.log_out1 img{
  width: 42px;
  display: block;
  margin: auto;
}
.log_out2{
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #FFFFFF;
  margin-top: 16px;
  word-break: break-word;
  word-wrap: break-word;
}
.log_out3{
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 22px;
  text-align: center;
  color: #FFFFFF;
  opacity: 0.8;
  margin-top: 8px;
  word-break: break-word;
  word-wrap: break-word;
}
.cancel_btn{
    color: #F1C788;
    border-color: #F1C788;
    background: transparent;
}
.confirm_btn{
  /* width: 130px; */
  background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-radius: 4px;
  border-color: #F1C788;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  color: #04182A;
  margin-left: 20px;
  margin-bottom: 15px;
}
/* --over-- */
/* 滚动条 */
.one_box {
  overflow: auto;
  height: calc(100vh - 120px);
}
.one_box::-webkit-scrollbar {
  width: 5px;
}
.one_box::-webkit-scrollbar-thumb {
  border-radius: 5px;
  /* -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2); */
  background: #F1C788;
}
/* --over-- */
.down_pdf{
    color: #DEB981;
    margin-top: 7px;
    display: block;
}
.down_pdf img{
    vertical-align: middle;
    width: 12px;
    margin-right: 7px;
    margin-top: -3px;
}
</style>
<style>
.el-upload-list__item {
    transition: none !important;
}
</style>

<style scoped>
@media screen and (max-width: 850px) {
    .one_main {
        margin: auto;
        width: 100%;
    }


}
</style>